import React, { useContext, useEffect, useRef, useState } from 'react';
import './Billprint2.css';
import NotoSansKannada from "../../Fonts/NotoSansKannada.ttf";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import { Font } from '@react-pdf/renderer';
import LatoItalicFont from "../../Fonts/Baloo2-VariableFont_wght.ttf";
import Logo from "../../imgs/dairylogo.png";
import { UilEditAlt, UilTrash } from '@iconscout/react-unicons'
import { green, lightGreen } from '@mui/material/colors';
import Globalcontext from '../../Context/Globalcontext';
import Cowsmall from "../../imgs/cowsmall.gif";
import Grass from "../../imgs/grass.png";
import { LanRounded } from '@mui/icons-material';
import { useTranslation } from "react-i18next";

// Register the font using the imported variable
Font.register({
    family: 'Lato-Italic',
    src: LatoItalicFont,
});
Font.register({
    family: "Kannada",
    src: NotoSansKannada,
});


const Billprint = (props) => {
    const { t, i18n } = useTranslation();
    const [currentPage, setCurrentPage] = useState(0);
    const [customerData, setCustomerData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [loadedPages, setLoadedPages] = useState(1);
    let bothornotmain = "";


    const loadMorePages = () => {
        setIsLoading(true);
        const pagesToLoad = 1; // Change this to load more pages

        setTimeout(() => {
            setLoadedPages(loadedPages + pagesToLoad);
            setIsLoading(false);
        }, 1000);
    };

    useEffect(() => {
        console.log(localStorage.getItem("customerData"));
        setTimeout(() => {

            if (JSON.parse(localStorage.getItem("customerData"))) {
                setCustomerData(JSON.parse(localStorage.getItem("customerData")));
                // Set loading to false when data is ready
                setIsLoading(false);
            }
        }, 200);
    }, []);

    const pageDataLength = parseFloat(Object.keys(customerData).length) / 2;
    const minutes = Math.floor(pageDataLength / 60);
    const seconds = pageDataLength % 60;

    return (
        <div className="billprintmain">
            <PDFViewer className='pdf'>
                <Document>
                    {Object.keys(customerData).map((kno, index) => (
                        <PageTemplate key={index} data={customerData[kno]} index={index} kno={kno} min={minutes} sec={seconds} pages={parseFloat(pageDataLength) * 2} t={t} lang={i18n.language} />
                    ))}
                </Document>
            </PDFViewer>
        </div>
    );
};

function PageTemplate({ data, index, kno, min, sec, pages, t, lang }) {
    const fontBase = (lang || "").toLowerCase().startsWith("kn") ? "Kannada" : "Lato-Italic";

    const [kapat, setKapat] = useState({});

    const [isGenerating, setIsGenerating] = useState(true);

    const generatePageContent = async () => {
        // Simulate page generation
        await new Promise(resolve => setTimeout(resolve, 1000)); // Adjust the duration as per your page generation time
        setIsGenerating(false); // Set isGenerating to false when the page is ready
    };

    useEffect(() => {
        generatePageContent();
    }, []);


    const getDatesInRange = (date1, date2) => {
        const dates = [];
        const currentDate = new Date(date1);

        while (currentDate <= new Date(date2)) {
            dates.push(currentDate.toISOString().split('T')[0]);
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return dates;
    };

    const getTableDataWithZeros = (tableData, date1, date2, type, time) => {
        if (!Array.isArray(tableData)) {
            return Array.from({ length: getDatesInRange(date1, date2).length }, (_, index) => ({
                sr: '',
                date: getDatesInRange(date1, date2)[index],
                time: time,
                kno: '',
                type: type,
                liter: '0',
                fat: '0',
                snf: '0',
                rate: '0',
                amt: '0.00',
                date1: date1,
                date2: date2,
                kendra: '',
            }));
        }

        const dateRange = getDatesInRange(date1, date2);
        const tableWithData = [];

        dateRange.forEach(date => {
            const matchingEntry = tableData.find(
                entry => entry.date === date && entry.type === type && entry.time === time
            );

            if (matchingEntry) {
                tableWithData.push(matchingEntry);
            } else {
                // Create a record with zero values
                tableWithData.push({
                    sr: '',
                    date: date,
                    time: time,
                    kno: '',
                    type: type,
                    liter: '0',
                    fat: '0',
                    snf: '0',
                    rate: '0',
                    amt: '0.00',
                    date1: date1,
                    date2: date2,
                    kendra: '',
                });
            }
        });

        return tableWithData;
    };


    const styles = StyleSheet.create({
        page: {
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 14,
            paddingRight: 14,
            backgroundColor: '#FFFFFF',
            flexDirection: 'column',     // ✅ not row

        },
        pageWithMargin: {
            backgroundColor: "lightblue"
        },
        header: {
            position: 'absolute',
            top: 0, // Adjust this value to change the vertical position
            left: 0,
            right: 0,
            textAlign: 'center',
        },
        loading: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center'
        },
        tableContainer: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between',
        },
        table: {
            display: 'table',
            width: 'auto', // Adjust as needed to fit four tables in a row
            margin: 5,
            marginLeft: -1,
        },
        tableone: {
            display: 'table',
            width: '18%', // Adjust as needed to fit four tables in a row
            margin: 5,
        },
        tableCellone: {
            border: '0.5px solid black',
            padding: 0.5,
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 3,
            flex: 1, // Remove width and use flex to distribute space equally
        },

        tableCellonebig: {
            border: '0.5px solid black',
            fontSize: 9.5,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '85mm', // Set the width of the individual cell
            fontWeight: 'bold'
        },
        tableCellonebig2: {
            border: '0.5px solid #000',
            fontSize: 9.5,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '10px',
            width: '85mm', // Set the width of the individual cell
            fontWeight: 'bold'
        },
        tableCellonebigdata: {
            border: '0.5px solid black',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '3mm',
            width: '85mm', // Set the width of the individual cell
            fontWeight: 'bold'
        },
        tableCellsmamt: {
            border: '0.5px solid black',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 2,
            width: '18mm', // Set the width of the individual cell

        },
        tableRowone: {
            flexDirection: 'row',
            width: '65%',
            height: 17,
            textAlign: 'right',
            marginLeft: -5,
        },
        tableRowonebig: {
            flexDirection: 'row',
            width: '80%',
            height: 17,
            textAlign: 'right',
            marginLeft: -5,
        },
        tableHeaderone: {
            flexDirection: 'row',
            width: '65%',
            height: 17,
            textAlign: 'right',
            border: '0.5px solid #000',
            marginLeft: -5,
            backgroundColor: 'lightgray'
        },
        tableHeaderonebig: {
            flexDirection: 'row',
            width: '80%',
            height: 17,
            textAlign: 'right',
            border: '0.5px solid #000',
            marginLeft: -5,
            backgroundColor: 'lightgray'
        },
        allbill: {
            flexDirection: 'row',
            width: '65%',
            textAlign: 'right',
            height: 17,
            marginLeft: -5,
            backgroundColor: 'lightgray',
            marginTop: 5
        },
        allbillbig: {
            border: '0.5px solid black',
            flexDirection: 'row',
            width: '80%',
            textAlign: 'right',
            height: 17,
            marginLeft: -5,
            backgroundColor: 'lightgray',
            marginTop: 5
        },
        tableRow: {
            flexDirection: 'row',
            height: 17,
            marginLeft: 3,
        },
        tableRow2: {
            flexDirection: 'row',
            height: 17,
            marginLeft: 3,
            marginTop: 5,
            backgroundColor: 'lightgray'
        },
        line: {
            flexDirection: 'row',
            backgroundColor: 'lightgray',
            height: 1,
            marginTop: -2,
            width: '100%',
        },
        tableHeader: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '5mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersm: {
            border: '0.5px solid #000',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '11mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersmbig: {
            border: '0.5px solid #000',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '14mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersmbig2: {
            border: '0.5px solid #000',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '13mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersmbig3: {
            border: '0.5px solid #000',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 2,
            width: '19mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadermed: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '13mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadermedbig: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 9,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '13mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadermed2: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '19mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadermed2big: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '19mm', // Set the width of the individual cell
            backgroundColor: 'black',
        },
        tableCell: {
            border: '0.5px solid black',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '1mm', // Set the width of the individual cell
        },
        tableCellbig: {
            border: '0.5px solid black',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '1mm', // Set the width of the individual cell
        },
        tableCellsm: {
            border: '0.5px solid black',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '11mm', // Set the width of the individual cell

        },
        tableCellsmbig: {
            border: '0.5px solid black',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '14mm', // Set the width of the individual cell

        },
        tableCellmed: {
            border: '0.5px solid black',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '1mm',
            width: '13mm', // Set the width of the individual cell
        },
        tableCellmedbig: {
            border: '0.5px solid black',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '1mm',
            width: '13mm', // Set the width of the individual cell
        },
        tableCellmed2: {
            border: '0.5px solid black',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '1mm',
            width: '19mm', // Set the width of the individual cell
        },
        tableCellmed2big: {
            border: '0.5px solid black',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '1mm',
            width: '19mm', // Set the width of the individual cell
        },
        latoText: {
            fontFamily: fontBase,
            fontSize: 15,
            marginBottom: 5,
            textAlign: 'center',
            width: '100%',
            fontWeight: 'bold',
            marginTop: 1,
        },
        headtextsmall: {
            fontFamily: fontBase,
            fontSize: 10,
            fontWeight: 'bold',
        },
        headtextsmall2: {
            fontFamily: fontBase,
            fontSize: 11,

            marginRight: 20,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmall3: {
            fontFamily: fontBase,
            fontSize: 14,
            color: 'rgb(156, 44, 24)',
            fontWeight: 'bold',
            alignSelf: 'center'
        },
        headtextsmall4: {
            fontFamily: fontBase,
            fontSize: 10,
            color: 'rgb(156, 44, 24)',
            fontWeight: 'bold',
            alignSelf: 'center'
        },
        headtextsmallleft1: {
            fontFamily: fontBase,
            fontSize: 9,
            marginLeft: -70,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmallleft2: {
            fontFamily: fontBase,
            fontSize: 9,
            marginLeft: 0,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmallleft3: {
            fontFamily: fontBase,
            fontSize: 9,
            marginLeft: 0,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmallleft4: {
            fontFamily: fontBase,
            fontSize: 9,
            marginRight: -50,
            marginTop: -5,
            fontWeight: 'bold',
        },

        headtextsmallleft1big: {
            fontFamily: fontBase,
            fontSize: 11,
            marginLeft: -70,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmallleft2big: {
            fontFamily: fontBase,
            fontSize: 11,
            marginLeft: 0,
            marginTop: -5,
            fontWeight: 'bold',
        },

        row: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
        },
        row1: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 5
        },
        row2: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: 140,
            paddingRight: 140,
            backgroundColor: 'lightgray',
        },
        row2both: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: 180,
            paddingRight: 180,
            backgroundColor: 'lightgray',
        },
        row2single: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: '250px',
            backgroundColor: 'lightgray',
        },
        column1: {
            display: 'flex',
            flexDirection: 'column',
            width: '23%',
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            paddingLeft: 5,
            paddingRight: 5,
            marginLeft: 20,
        },
        column2: {
            display: 'flex',
            flexDirection: 'column',
            width: '15%',
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            paddingLeft: 5,
            paddingRight: 5,
        },
        column3: {
            border: '1px solid black',
            display: 'flex',
            flexDirection: 'column',
            width: '17%',
            height: '89%',
            justifyContent: 'start',
            margin: 5,
            marginLeft: 2,
            alignItems: 'flex-start', // Align text to the left
        },
        column3blank: {
            display: 'flex',
            flexDirection: 'column',
            width: '17%',
            height: '89%',
            justifyContent: 'start',
            margin: 5,
            marginLeft: 2,
            alignItems: 'flex-start', // Align text to the left
        },

        grayhead: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            paddingBottom: 3,
            justifyContent: 'center',
            alignItems: 'flex-start', // Align text to the left
            backgroundColor: 'lightgray',
        },

        column1Row: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
        },
        columnbottom: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            padding: 3
        },
        simplerow: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',

        },
        simplecol: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            marginTop: -1
        },
        column1Rowgray: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            padding: 4,
            marginTop: 3,
            marginBottom: 5,
            border: '0.5px solid black',
            backgroundColor: 'lightgray'
        },
        column1Label: {
            fontFamily: fontBase,
            fontSize: 8,
            fontWeight: 'bold',
            textAlign: 'left', // Align labels to the left
        },
        column1Labelgray: {
            fontFamily: fontBase,
            fontSize: 9,
            fontWeight: 'bold',
            textAlign: 'center', // Align labels to the left
        },
        column1Labelgreen: {
            fontFamily: fontBase,
            fontSize: 12,
            fontWeight: 'bold',
            textAlign: 'center', // Align labels to the left
        },
        column1Value: {
            fontFamily: fontBase,
            fontSize: 8,
            fontWeight: 'bold',
            textAlign: 'right', // Align values to the right
        },
        pageBreak: {
            pageBreakBefore: 'always',
        },
        totalsRow: {
            flexDirection: 'row',
            borderTop: '1px solid #000',
            paddingTop: 5,
            paddingLeft: 2,
        },
        totalsCell: {
            border: '0.5px solid black',
            padding: 0.5,
            flex: 1,
            fontSize: 8,
            width: 2,
            textAlign: 'center',
        },
        imagerow: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: -15
        },
        image: {
            width: 60, // Adjust the width as needed
            height: "28", // Maintain aspect ratio
            marginTop: -3,
            alignSelf: "center",
            marginLeft: -20
        },
        imgtext: {
            fontFamily: fontBase,
            fontSize: 9,
            fontWeight: 'bold',
            textAlign: 'center', // Align labels to the left
        },
        tableCellgreen: {
            border: '0.5px solid black',
            padding: 0.5,
            flex: 1,
            fontSize: 12,
            fontWeight: 'bold',
            fontFamily: fontBase,
            color: 'green',
            width: 2,
            fontWeight: 'bold',
            textAlign: 'center',
        },
        tableCellred: {
            border: '0.5px solid black',
            padding: 0.5,
            flex: 1,
            fontSize: 12,
            fontWeight: 'bold',
            fontFamily: fontBase,
            color: 'red',
            width: 3,
            fontWeight: 'bold',
            textAlign: 'center',
        },
        loadingSpinner: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: 16,
            fontWeight: 'bold',
            color: 'gray',
        },
        tableHeadersmbigacc: {
            border: '0.5px solid #000',
            fontSize: 9,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '16mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersmbigaccblank: {
            fontSize: 9,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '15mm', // Set the width of the individual cell
        },
        tableHeadersmbigaccwhite: {
            border: '0.5px solid #000',
            fontSize: 9,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingLeft: '2px',
            paddingRight: '5px',
            width: '16mm', // Set the width of the individual cell
        },
        tableRowacc: {
            flexDirection: 'row',
            height: 19.4,
            marginLeft: 3,
            textAlign: 'center',

        },

    });

    const knoData = data;
    const groupByTypeAndTime = {};

    let tlitermhmor = 0;
    let tlitermhevn = 0;
    let tlitergaymor = 0;
    let tlitergayevn = 0;

    // Group data by 'type' and 'time'
    knoData.forEach(entry => {
        const key = entry.type + '-' + entry.time;
        tlitermhmor = entry.tlitermhmor;
        tlitermhevn = entry.tlitermhevn;
        tlitergaymor = entry.tlitergaymor;
        tlitergayevn = entry.tlitergayevn;
        if (!groupByTypeAndTime[key]) {
            groupByTypeAndTime[key] = [];
        }
        groupByTypeAndTime[key].push(entry);
    });

    const tableDataArrays = ['Buffalo-Morning', 'Buffalo-Evening', 'Cow-Morning', 'Cow-Evening'].map((typeTimeKey) => {
        const [type, time] = typeTimeKey.split('-');
        const entries = groupByTypeAndTime[typeTimeKey]; // You should define 'groupByTypeAndTime' based on your data structure.
        return getTableDataWithZeros(entries, knoData[0].date1, knoData[0].date2, type, time);
    });

    function formatDate(inputDate) {
        const options = { day: '2-digit', month: '2-digit', year: '2-digit' };
        return new Date(inputDate).toLocaleDateString('IN', options);
    }


    const calculateSumOfAmtColumns = (tableDataArray) => {
        const sums = Array.from({ length: tableDataArray[0].length }, () => 0); // Initialize an array with zeros based on the length of the first table

        // Loop through the tables and calculate sums for each record
        tableDataArray.forEach((tableDataWithZeros) => {
            tableDataWithZeros.forEach((entry, entryIndex) => {
                sums[entryIndex] += parseFloat(entry.amt);
            });
        });
        return sums;
    };

    const sumsOfAmtColumns = calculateSumOfAmtColumns(tableDataArrays);
    //  console.log("sumsOfAmtColumns: ", sumsOfAmtColumns);
    const sumOfFifthTable = sumsOfAmtColumns.reduce((total, sum) => total + parseFloat(sum), 0).toFixed(2);
    let totalOfTotalLiter = 0;
    let totalOfTotalFat = 0;
    let tkapat = 0;
    let tyene = 0;
    let ada = 0;

    let zeroflagmh = false;
    let zeroflaggay = false;

    let zeroflagmhevn = false;
    let zeroflaggayevn = false;

    let totalLiterMh = 0;
    let totalLiterGay = 0;

    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);
    const [isboth, setIsboth] = useState(false);

    useEffect(() => {
        if (zeroflagmh && zeroflaggay) {
            //   console.log("in both");
            setIsboth(true);
        }
    }, [zeroflagmh, zeroflaggay]);

    const renderTable = (tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate) => {
        return (
            <View key={typeTimeKey} style={styles.table}>
                {/* Table Header */}
                <View style={styles.tableRow}>
                    {tableIndex == dateflag ? (
                        <Text
                            style={[
                                bothornot === "both" ? styles.tableHeadersm : styles.tableHeadersmbig,
                                { width: bothornot === "both" ? 38 : 38 }
                            ]}
                        >
                            {t("billprint3.table.date")}
                        </Text>
                    ) : null}

                    <Text style={bothornot === "both" ? styles.tableHeadersm : styles.tableHeadersmbig}>
                        {t("billprint3.table.liter")}
                    </Text>

                    <Text style={bothornot === "both" ? styles.tableHeadersm : styles.tableHeadersmbig}>
                        {t("billprint3.table.fat")}
                    </Text>

                    <Text style={bothornot === "both" ? styles.tableHeadersm : styles.tableHeadersmbig}>
                        {t("billprint3.table.snf")}
                    </Text>

                    <Text style={bothornot === "both" ? styles.tableHeadermed : styles.tableHeadersmbig2}>
                        {t("billprint3.table.rate")}
                    </Text>

                    <Text style={bothornot === "both" ? styles.tableHeadermed2 : styles.tableHeadersmbig3}>
                        {t("billprint3.table.amount")}
                    </Text>
                </View>

                {/* Table Data */}
                {tableDataWithZeros.map((entry, entryIndex) => (
                    <View key={entryIndex} style={styles.tableRow}>
                        {tableIndex == dateflag ? ( // Render "दिनांक" only for the first table
                            <Text style={[bothornot === "both" ? styles.tableCell : styles.tableCellbig, { width: 38 }]}>
                                {entry.date.substr(5).split('-').reverse().join('/')}
                            </Text>
                        ) : null}
                        {
                            entry.liter === '0' ?
                                <>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}></Text>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}></Text>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}></Text>
                                    <Text style={bothornot === "both" ? styles.tableCellmed : styles.tableCellmedbig}></Text>
                                    <Text style={bothornot === "both" ? styles.tableCellmed2 : styles.tableCellmed2big}></Text>
                                </>
                                :
                                <>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}>{entry.liter}</Text>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}>{entry.fat}</Text>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}>{entry.snf}</Text>
                                    <Text style={bothornot === "both" ? styles.tableCellmed : styles.tableCellmedbig}>{parseFloat(entry.rate).toFixed(2)}</Text>
                                    <Text style={bothornot === "both" ? styles.tableCellmed2 : styles.tableCellmed2big}>{parseFloat(entry.amt).toFixed(2)}</Text>
                                </>
                        }
                    </View>
                ))}
                {/* Totals Row */}
                <View style={styles.tableRow2}>
                    {tableIndex == dateflag ? ( // Render "दिनांक" only for the first table
                        <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig, { width: bothornot === "both" ? 35 : 39 }]}>एकूण</Text>
                    ) : null}
                    {/* <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{totalLiter.toFixed(2)}</Text> */}
                    {/* <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{avgfat ? avgfat.toFixed(1) : "0.0"}</Text> */}
                    {/* <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{avgsnf ? avgsnf.toFixed(1) : "0.0"}</Text> */}
                    {/* <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig2]}></Text> */}
                    {/* <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig3]}>{totalAmt.toFixed(2)}</Text> */}

                    <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{totalLiter.toFixed(1)}</Text>
                    {

                        localStorage.getItem("avg") === "On" ?
                            <>
                                <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{avgfat ? avgfat.toFixed(1) : "0.0"}</Text>
                                <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{avgsnf ? avgsnf.toFixed(1) : "0.0"}</Text>
                                <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig2]}>{avgrate ? avgrate.toFixed(2) : "0.0"}</Text>
                            </>
                            :
                            <>
                                <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{"-"}</Text>
                                <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{"-"}</Text>
                                <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig2]}>{"-"}</Text>
                            </>
                    }
                    <Text style={[bothornot === "both" ? styles.tableCellsmamt : styles.tableHeadersmbig3]}>{totalAmt.toFixed(2)}</Text>

                </View>
            </View>
        );
    };

    let dateflag = "";
    let bothornot = "";
    let milktype = "";

    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor == null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "not";
        milktype = "Buffalo";

    }

    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor == null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "not";
        milktype = "Buffalo";

    }

    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor != null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 2;
        bothornot = "not";
        milktype = "Cow";

    }

    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor != null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor == null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";
    }


    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor == null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "not";
        milktype = "Buffalo";
    }

    // Remaining combinations

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor == null && tlitergayevn == null) {
        //

    }

    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor != null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "both";
    }

    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor == null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn == null) {
        dateflag = 2;
        bothornot = "not";
        milktype = "Cow";

    }

    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor == null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor == null && tlitergayevn != null) {
        dateflag = 2;
        bothornot = "not";
        milktype = "Cow";
    }

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 2;
        bothornot = "not";
        milktype = "Cow";
    }

    return (
        <>
            <Page
                key={index}
                size={localStorage.getItem("dur") === "10" ? "A5" : "A4"}
                orientation={localStorage.getItem("dur") === "10" ? "landscape" : "portrait"}
                style={[
                    bothornot === "both" ? styles.pageboth : styles.page,
                    { fontFamily: fontBase }
                ]}
            >
                {isGenerating ? (
                    <View style={styles.loading}>
                        <Text style={styles.headtextsmall3}>
                            {t("billprint3.loading.generating", { min, sec })}
                        </Text>
                        <Text style={styles.headtextsmall4}>
                            {t("billprint3.loading.totalPages", { pages })}
                        </Text>
                    </View>

                ) : (

                    <View>
                        <View style={styles.row1}>
                            <Text style={styles.headtextsmall}>
                                {t("billprint3.header.period", {
                                    from: formatDate(knoData[0].date1),
                                    to: formatDate(knoData[0].date2),
                                })}
                            </Text>

                            <Text style={styles.headtextsmall2}>
                                {t("billprint3.header.kendraCity", {
                                    kendra: knoData[0].kendra,
                                    city: localStorage.getItem("city") || "",
                                })}
                            </Text>

                            <Text style={styles.headtextsmall}>
                                {t("billprint3.header.account", {
                                    kno,
                                    name: knoData[0].cname,
                                })}
                            </Text>
                        </View>

                        (
                        {
                            bothornot === "both" ?
                                <View>
                                    <View style={styles.row2}>
                                        <Text style={styles.headtextsmall}>{t("customer.milk_types.buffalo")}</Text>
                                        <Text style={styles.headtextsmall}>{t("customer.milk_types.cow")}</Text>
                                    </View>
                                    <View style={styles.row2}>
                                        <Text style={styles.headtextsmallleft1}>{t("common.morning")}</Text>
                                        <Text style={styles.headtextsmallleft2}>{t("common.evening")}</Text>
                                        <Text style={styles.headtextsmallleft3}>{t("common.morning")}</Text>
                                        <Text style={styles.headtextsmallleft4}>{t("common.evening")}</Text>
                                    </View>
                                </View>
                                :
                                <View>
                                    <View style={styles.row2single}>
                                        <Text style={styles.headtextsmall}>
                                            {milktype === "Buffalo"
                                                ? t("customer.milk_types.buffalo")
                                                : milktype === "Cow"
                                                    ? t("customer.milk_types.cow")
                                                    : t("customer.milk_types.both")}
                                        </Text>
                                    </View>
                                    <View style={styles.row2both}>
                                        <Text style={styles.headtextsmallleft1big}>{t("common.morning")}</Text>
                                        <Text style={styles.headtextsmallleft2big}>{t("common.evening")}</Text>
                                    </View>
                                </View>
                        }
                        )

                        <View style={styles.tableContainer}>
                            {
                                ['Buffalo-Morning', 'Buffalo-Evening', 'Cow-Morning', 'Cow-Evening'].map((typeTimeKey, tableIndex) => {
                                    const [type, time] = typeTimeKey.split('-'); // Split type and time
                                    const entries = groupByTypeAndTime[typeTimeKey];
                                    const tableDataWithZeros = getTableDataWithZeros(entries, knoData[0].date1, knoData[0].date2, type, time);

                                    // Calculate totals
                                    const totalLiter = tableDataWithZeros.reduce((total, entry) => total + parseFloat(entry.liter), 0);
                                    totalOfTotalLiter += totalLiter;

                                    const totalFat = tableDataWithZeros
                                        .filter(entry => entry.fat > 0) // Filter entries where fat is greater than 0
                                        .reduce((total, entry) => total + parseFloat(entry.fat), 0); // Sum up the fat values

                                    const totalEntriesWithFat = tableDataWithZeros
                                        .filter(entry => entry.fat > 0) // Filter entries where fat is greater than 0
                                        .length;

                                    const avgfat = totalFat / totalEntriesWithFat;

                                    const totalSNF = tableDataWithZeros
                                        .filter(entry => entry.fat > 0) // Filter entries where fat is greater than 0
                                        .reduce((total, entry) => total + parseFloat(entry.snf), 0); // Sum up the fat values

                                    const totalEntriesWithSNF = tableDataWithZeros
                                        .filter(entry => entry.snf > 0) // Filter entries where fat is greater than 0
                                        .length;

                                    const avgsnf = totalSNF / totalEntriesWithSNF;

                                    const totalRate = tableDataWithZeros
                                        .filter(entry => entry.rate > 0) // Filter entries where fat is greater than 0
                                        .reduce((total, entry) => total + parseFloat(entry.rate), 0); // Sum up the fat values

                                    const totalEntriesWithRate = tableDataWithZeros
                                        .filter(entry => entry.rate > 0) // Filter entries where fat is greater than 0
                                        .length;

                                    const avgrate = totalRate / totalEntriesWithRate;


                                    tkapat = parseFloat(knoData[0].cthev !== null && !isNaN(knoData[0].cthev) ? knoData[0].cthev : 0)
                                        + parseFloat(knoData[0].cthevitr1 !== null && !isNaN(knoData[0].cthevitr1) ? knoData[0].cthevitr1 : 0)
                                        + parseFloat(knoData[0].cthevitr2 !== null && !isNaN(knoData[0].cthevitr2) ? knoData[0].cthevitr2 : 0)
                                        + parseFloat(knoData[0].cthevitr3 !== null && !isNaN(knoData[0].cthevitr3) ? knoData[0].cthevitr3 : 0)
                                        + parseFloat(knoData[0].itrkapat1 !== null && !isNaN(knoData[0].itrkapat1) ? knoData[0].itrkapat1 : 0)
                                        + parseFloat(knoData[0].itrkapat2 !== null && !isNaN(knoData[0].itrkapat2) ? knoData[0].itrkapat2 : 0)
                                        + parseFloat(knoData[0].itrkapat3 !== null && !isNaN(knoData[0].itrkapat3) ? knoData[0].itrkapat3 : 0)
                                        + parseFloat(knoData[0].retan !== null && !isNaN(knoData[0].retan) ? knoData[0].retan : 0)
                                        + parseFloat(knoData[0].medi !== null && !isNaN(knoData[0].medi) ? knoData[0].medi : 0)
                                        + parseFloat(knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? knoData[0].advkapat : 0)
                                        + parseFloat(knoData[0].ratibkapat !== null && !isNaN(knoData[0].ratibkapat) ? knoData[0].ratibkapat : 0)
                                        + parseFloat(knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? knoData[0].khadyakapat : 0)
                                        + parseFloat(knoData[0].karjhpta !== null && !isNaN(knoData[0].karjhpta) ? knoData[0].karjhpta : 0)
                                        + parseFloat(knoData[0].karjintr !== null && !isNaN(knoData[0].karjintr) ? knoData[0].karjintr : 0)
                                        + parseFloat(knoData[0].sanghkapat !== null && !isNaN(knoData[0].sanghkapat) ? knoData[0].sanghkapat : 0)
                                        + parseFloat(knoData[0].cbhishi !== null && !isNaN(knoData[0].cbhishi) ? knoData[0].cbhishi : 0)
                                        + parseFloat(knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter) ? parseFloat(knoData[0].ikapatliter) : 0) + parseFloat(knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill).toFixed(2) : 0) //+ parseFloat(knoData[0].vah !== null && !isNaN(knoData[0].vah) ? (parseFloat(knoData[0].vah)) : 0)

                                    {
                                        localStorage.getItem("billtype") === "oldbill" ?
                                            tyene = parseFloat(knoData[0].newadv !== null && !isNaN(knoData[0].newadv) ? knoData[0].newadv : 0)
                                            + parseFloat(knoData[0].newkhadya !== null && !isNaN(knoData[0].newkhadya) ? knoData[0].newkhadya : 0)
                                            + parseFloat(knoData[0].newratib !== null && !isNaN(knoData[0].newratib) ? knoData[0].newratib : 0)
                                            + parseFloat(knoData[0].newretanmedi !== null && !isNaN(knoData[0].newretanmedi) ? knoData[0].newretanmedi : 0)
                                            + parseFloat(knoData[0].newkarj !== null && !isNaN(knoData[0].newkarj) ? knoData[0].newkarj : 0)
                                            + parseFloat(knoData[0].newsangh !== null && !isNaN(knoData[0].newsangh) ? knoData[0].newsangh : 0)
                                            :
                                            tyene = '0';
                                    }

                                    ada = parseFloat(parseFloat(sumOfFifthTable) - parseFloat(tkapat) + parseFloat(knoData[0].vah !== null && !isNaN(knoData[0].vah) ? (parseFloat(knoData[0].vah)) : 0) + parseFloat(knoData[0].comm !== null && !isNaN(knoData[0].comm) ? (parseFloat(knoData[0].comm)) : 0)).toFixed(2);

                                    const totalAmt = tableDataWithZeros.reduce((total, entry) => total + parseFloat(entry.amt), 0);

                                    dateflag = "";
                                    bothornot = "";

                                    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor != null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";

                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor == null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "not";
                                        if (type == 'Buffalo') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor == null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "not";
                                        if (type == 'Buffalo') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor != null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor != null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
                                        dateflag = 2;
                                        bothornot = "not";
                                        if (type == 'Cow') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor != null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor == null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor == null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "not";
                                        if (type == 'Buffalo') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    // Remaining combinations

                                    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor == null && tlitergayevn == null) {
                                        //
                                    }

                                    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor != null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor == null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn == null) {
                                        dateflag = 2;
                                        bothornot = "not";
                                        if (type == 'Cow') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor == null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor == null && tlitergayevn != null) {
                                        dateflag = 2;
                                        bothornot = "not";
                                        if (type == 'Cow') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
                                        dateflag = 2;
                                        bothornot = "not";
                                        if (type == 'Cow') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }
                                })
                            }

                            <View style={styles.tableone}>
                                <View style={bothornot === "both" ? styles.tableHeaderone : styles.tableHeaderonebig}>
                                    <Text style={bothornot === "both" ? styles.tableCellone : styles.tableCellonebig}>
                                        {t("common.amount")}
                                    </Text>
                                </View>

                                {sumsOfAmtColumns.map((sum, entryIndex) => (
                                    <View
                                        key={entryIndex}
                                        style={bothornot === "both" ? styles.tableRowone : styles.tableRowonebig}
                                    >
                                        <Text style={bothornot === "both" ? styles.tableCellone : styles.tableCellonebigdata}>
                                            {sum.toFixed(2)}
                                        </Text>
                                    </View>
                                ))}

                                <View style={bothornot === "both" ? styles.allbill : styles.allbillbig}>
                                    <Text style={bothornot === "both" ? styles.tableCellone : styles.tableCellonebig2}>
                                        {sumOfFifthTable}
                                    </Text>
                                </View>
                            </View>

                        </View>

                        <View style={styles.line} />

                        <View style={styles.row}>
                            {
                                localStorage.getItem("design") === "1" ?
                                    <View>
                                        <View style={styles.table}>
                                            <View style={styles.tableRowacc}>
                                                <Text style={styles.tableHeadersmbigacc}>{"--"}</Text>
                                                <Text style={styles.tableHeadersmbigacc}>{t("billprint.deposit")}</Text>

                                                {localStorage.getItem("itr1name") != "-" ? (
                                                    <Text style={styles.tableHeadersmbigacc}>{localStorage.getItem("itr1name")}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("itr2name") != "-" ? (
                                                    <Text style={styles.tableHeadersmbigacc}>{localStorage.getItem("itr2name")}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("itr3name") != "-" ? (
                                                    <Text style={styles.tableHeadersmbigacc}>{localStorage.getItem("itr3name")}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}

                                                <Text style={styles.tableHeadersmbigacc}>{t("billprint.advance")}</Text>
                                                <Text style={styles.tableHeadersmbigacc}>{t("billprint.khady")}</Text>
                                                <Text style={styles.tableHeadersmbigacc}>{t("billprint.ratib")}</Text>

                                                {localStorage.getItem("retan") === "On" ? (
                                                    <Text style={styles.tableHeadersmbigacc}>{t("bill.th.cowRetan")}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("karj") === "On" ? (
                                                    <Text style={styles.tableHeadersmbigacc}>{t("bill.th.interest")}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("sanghk") === "On" ? (
                                                    <Text style={styles.tableHeadersmbigacc}>{t("sangh.labels.name")}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("itrname") != "-" ? (
                                                    <Text style={styles.tableHeadersmbigacc}>{localStorage.getItem("itrname")}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                            </View>

                                            <View style={styles.tableRowacc}>
                                                <Text style={styles.tableHeadersmbigacc}>{t("billprint.commonBox.prev")}</Text>
                                                <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].mthev).toFixed(2)}</Text>

                                                {localStorage.getItem("itr1name") != "-" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].magilthevitr1).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("itr2name") != "-" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].magilthevitr2).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("itr3name") != "-" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].magilthevitr3).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}

                                                <Text style={styles.tableHeadersmbigaccwhite}>{knoData[0].madv}</Text>
                                                <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].mkhadya).toFixed(2)}</Text>
                                                <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].mratib).toFixed(2)}</Text>

                                                {localStorage.getItem("retan") === "On" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].magilretanmedi).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("karj") === "On" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].mkarj).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("sanghk") === "On" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].magilsangh).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("itrname") != "-" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].magilbhishi).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                            </View>

                                            <View style={styles.tableRowacc}>
                                                <Text style={styles.tableHeadersmbigacc}>{t("billprint.commonBox.on")}</Text>
                                                <Text style={styles.tableHeadersmbigaccwhite}>{"-"}</Text>

                                                {localStorage.getItem("itr1name") != "-" ? <Text style={styles.tableHeadersmbigaccwhite}></Text> : <Text></Text>}
                                                {localStorage.getItem("itr2name") != "-" ? <Text style={styles.tableHeadersmbigaccwhite}></Text> : <Text></Text>}
                                                {localStorage.getItem("itr3name") != "-" ? <Text style={styles.tableHeadersmbigaccwhite}></Text> : <Text></Text>}

                                                <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].cadv).toFixed(2)}</Text>
                                                <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].ckhadya).toFixed(2)}</Text>
                                                <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].cratib).toFixed(2)}</Text>

                                                {localStorage.getItem("retan") === "On" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].cretanmedi).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("karj") === "On" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].ckarj).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("sanghk") === "On" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].csangh).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("itrname") != "-" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].cbhishi).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                            </View>

                                            <View style={styles.tableRowacc}>
                                                <Text style={styles.tableHeadersmbigacc}>{t("bill.sign.minus")}</Text>
                                                <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].cthev).toFixed(2)}</Text>

                                                {localStorage.getItem("itr1name") != "-" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{knoData[0].cthevitr1}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("itr2name") != "-" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{knoData[0].cthevitr2}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("itr3name") != "-" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{knoData[0].cthevitr3}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}

                                                <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].advkapat).toFixed(2)}</Text>
                                                <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].khadyakapat).toFixed(2)}</Text>
                                                <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].ratibkapat).toFixed(2)}</Text>

                                                {localStorage.getItem("retan") === "On" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>
                                                        {parseFloat(parseFloat(knoData[0].retan) + parseFloat(knoData[0].medi)).toFixed(2)}
                                                    </Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("karj") === "On" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(parseFloat(knoData[0].karjhpta)).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("sanghk") === "On" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(parseFloat(knoData[0].sanghkapat)).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("itrname") != "-" ? <Text style={styles.tableHeadersmbigaccwhite}>{"-"}</Text> : <Text></Text>}
                                            </View>

                                            <View style={styles.tableRowacc}>
                                                <Text style={styles.tableHeadersmbigacc}>{t("bill.th.payable")}</Text>
                                                <Text style={styles.tableHeadersmbigaccwhite}>{knoData[0].newthev}</Text>

                                                {localStorage.getItem("itr1name") != "-" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{knoData[0].newthevitr1}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("itr2name") != "-" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{knoData[0].newthevitr2}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("itr3name") != "-" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{knoData[0].newthevitr3}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}

                                                <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].newadv).toFixed(2)}</Text>
                                                <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].newkhadya).toFixed(2)}</Text>
                                                <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].newratib).toFixed(2)}</Text>

                                                {localStorage.getItem("retan") === "On" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].newretanmedi).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("karj") === "On" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].newkarj).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("sanghk") === "On" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].newsangh).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                                {localStorage.getItem("itrname") != "-" ? (
                                                    <Text style={styles.tableHeadersmbigaccwhite}>{parseFloat(knoData[0].newbhishi).toFixed(2)}</Text>
                                                ) : (
                                                    <Text></Text>
                                                )}
                                            </View>
                                        </View>
                                    </View>

                                    :
                                    <>
                                        <View style={styles.column1}>
                                            {localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.prevBalance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {parseFloat(
                                                            parseFloat(
                                                                (knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0) +
                                                                (knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0)
                                                            ).toFixed(2)
                                                        )}
                                                    </Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.prevBalance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {parseFloat(localStorage.getItem("bcount")) > 0
                                                            ? parseFloat(
                                                                parseFloat(
                                                                    (knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0) +
                                                                    (knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0)
                                                                ).toFixed(2)
                                                            )
                                                            : knoData[0].obal !== null && !isNaN(knoData[0].obal)
                                                                ? knoData[0].obal
                                                                : 0}
                                                    </Text>
                                                </View>
                                            )}

                                            {localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.khadyOn")}</Text>
                                                    <Text style={styles.column1Value}>{knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0}</Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.khadyOnN")}</Text>
                                                    <Text style={styles.column1Value}>{knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0}</Text>
                                                </View>
                                            )}

                                            {localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.advanceOn")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0).toFixed(2)}</Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.advanceOnN")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0).toFixed(2)}</Text>
                                                </View>
                                            )}
                                        </View>

                                        <View style={styles.column1}>
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint.summaryBox.totalBalance")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {parseFloat(
                                                        parseFloat(
                                                            parseFloat(
                                                                (knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0) +
                                                                (knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0)
                                                            ) +
                                                            (knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0) +
                                                            (knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0)
                                                        ).toFixed(2)
                                                    )}
                                                </Text>
                                            </View>

                                            {localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.directDeduct")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {parseFloat(
                                                            parseFloat(
                                                                (knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? parseFloat(knoData[0].advkapat).toFixed(2) : 0) +
                                                                (knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? parseFloat(knoData[0].khadyakapat).toFixed(2) : 0)
                                                            ).toFixed(2)
                                                        )}
                                                    </Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.directDeduct")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {parseFloat(
                                                            parseFloat(
                                                                (knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? parseFloat(knoData[0].advkapat).toFixed(2) : 0) +
                                                                (knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? parseFloat(knoData[0].khadyakapat).toFixed(2) : 0)
                                                            ).toFixed(2)
                                                        )}
                                                    </Text>
                                                </View>
                                            )}

                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint.summaryBox.dueBalance")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {parseFloat(
                                                        parseFloat(
                                                            parseFloat(
                                                                parseFloat(
                                                                    (knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0) +
                                                                    (knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0)
                                                                ) +
                                                                (knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0) +
                                                                (knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0)
                                                            ) -
                                                            parseFloat(
                                                                parseFloat(
                                                                    (knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? parseFloat(knoData[0].advkapat).toFixed(2) : 0) +
                                                                    (knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? parseFloat(knoData[0].khadyakapat).toFixed(2) : 0)
                                                                )
                                                            )
                                                        ).toFixed(2)
                                                    )}
                                                </Text>
                                            </View>
                                        </View>
                                    </>

                            }

                            <>
                                {
                                    <View style={styles.column3}>
                                        <View style={styles.grayhead}>
                                            <Text style={styles.column1Labelgray}>{t("billprint3.otherBox.title")}</Text>
                                        </View>

                                        <View style={styles.columnbottom}>
                                            {localStorage.getItem("itr4name") != "-" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{localStorage.getItem("itr4name")} : </Text>
                                                    <Text style={styles.column1Value}>{knoData[0].itrkapat1}</Text>
                                                </View>
                                            ) : (
                                                ""
                                            )}

                                            {localStorage.getItem("itr5name") != "-" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{localStorage.getItem("itr5name")} : </Text>
                                                    <Text style={styles.column1Value}>{knoData[0].itrkapat2}</Text>
                                                </View>
                                            ) : (
                                                ""
                                            )}

                                            {localStorage.getItem("itr6name") != "-" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{localStorage.getItem("itr6name")} : </Text>
                                                    <Text style={styles.column1Value}>{knoData[0].itrkapat3}</Text>
                                                </View>
                                            ) : (
                                                ""
                                            )}

                                            {parseFloat(knoData[0].karjhpta) > 0 ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.loanInterest")} : </Text>
                                                    <Text style={styles.column1Value}>{knoData[0].karjintr}</Text>
                                                </View>
                                            ) : (
                                                ""
                                            )}

                                            {parseFloat(knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill) : 0) > 0 ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{localStorage.getItem("itrmainname")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill).toFixed(2) : 0}
                                                    </Text>
                                                </View>
                                            ) : (
                                                ""
                                            )}
                                        </View>
                                    </View>

                                }
                            </>


                            <View style={styles.column3}>
                                <View style={styles.grayhead}>
                                    <Text style={styles.column1Labelgray}>{t("billprint3.totalSectionTitle")}</Text>
                                </View>

                                <View style={styles.columnbottom}>
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{t("billprint3.totalBox.liter")}</Text>
                                        <Text style={styles.column1Value}>{totalOfTotalLiter.toFixed(2)}</Text>
                                    </View>

                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{t("billprint3.totalBox.yene")}</Text>
                                        <Text style={styles.column1Value}>{tyene.toFixed(2)}</Text>
                                    </View>

                                    {localStorage.getItem("showother") === "Yes" ? (
                                        <>
                                            {parseFloat(
                                                knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter)
                                                    ? parseFloat(knoData[0].ikapatliter)
                                                    : 0
                                            ) > 0 ? (
                                                localStorage.getItem("billtype") === "oldbill" ? (
                                                    <View style={styles.column1Row}>
                                                        <Text style={styles.column1Label}>{t("billprint3.totalBox.otherDeductPerLiter")} </Text>
                                                        <Text style={styles.column1Value}>
                                                            {knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter)
                                                                ? parseFloat(knoData[0].ikapatliter)
                                                                : 0}
                                                        </Text>
                                                    </View>
                                                ) : (
                                                    <View style={styles.column1Row}>
                                                        <Text style={styles.column1Label}>{t("billprint3.totalBox.otherDeductPerLiterN")} </Text>
                                                        <Text style={styles.column1Value}>
                                                            {knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter)
                                                                ? parseFloat(parseFloat(knoData[0].ikapatliter) * parseFloat(totalOfTotalLiter)).toFixed(2)
                                                                : 0}
                                                        </Text>
                                                    </View>
                                                )
                                            ) : (
                                                ""
                                            )}
                                        </>
                                    ) : (
                                        ""
                                    )}
                                </View>
                            </View>

                            <View style={styles.column3}>
                                <View style={styles.grayhead}>
                                    <Text style={styles.column1Labelgray}>{t("billprint3.bill")}</Text>
                                </View>

                                <View style={styles.columnbottom}>
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{t("billprint3.billBox.sectionTotal")}</Text>
                                        <Text style={styles.column1Value}>{sumOfFifthTable}</Text>
                                    </View>

                                    {parseFloat(
                                        knoData[0].vah !== null && !isNaN(knoData[0].vah) ? parseFloat(knoData[0].vah) : 0
                                    ) > 0 ? (
                                        localStorage.getItem("billtype") === "oldbill" ? (
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint3.billBox.transportPlus")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {knoData[0].vah !== null && !isNaN(knoData[0].vah) ? parseFloat(knoData[0].vah).toFixed(2) : 0}
                                                </Text>
                                            </View>
                                        ) : (
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint3.billBox.transportOnly")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {knoData[0].mhvah !== null && !isNaN(knoData[0].mhvah)
                                                        ? parseFloat(parseFloat(knoData[0].mhvah) * parseFloat(totalOfTotalLiter)).toFixed(2)
                                                        : 0}
                                                </Text>
                                            </View>
                                        )
                                    ) : (
                                        ""
                                    )}

                                    {parseFloat(
                                        knoData[0].comm !== null && !isNaN(knoData[0].comm) ? parseFloat(knoData[0].comm) : 0
                                    ) > 0 ? (
                                        localStorage.getItem("billtype") === "oldbill" ? (
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint3.billBox.commissionPlus")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {knoData[0].comm !== null && !isNaN(knoData[0].comm) ? parseFloat(knoData[0].comm).toFixed(2) : 0}
                                                </Text>
                                            </View>
                                        ) : (
                                            ""
                                        )
                                    ) : (
                                        ""
                                    )}

                                    {localStorage.getItem("billtype") === "oldbill" ? (
                                        <View style={styles.column1Row}>
                                            <Text style={styles.column1Label}>{t("billprint3.billBox.totalDeduct")}</Text>
                                            <Text style={styles.column1Value}>{parseFloat(tkapat).toFixed(2)}</Text>
                                        </View>
                                    ) : (
                                        <View style={styles.column1Row}>
                                            <Text style={styles.column1Label}>{t("billprint3.billBox.totalDeductN")}</Text>
                                            <Text style={styles.column1Value}>
                                                {parseFloat(
                                                    parseFloat(knoData[0].mhliter * knoData[0].mhthev) +
                                                    parseFloat(knoData[0].gayliter * knoData[0].gaythev) +
                                                    parseFloat(kapat[kno] && !isNaN(kapat[kno].cuchal) ? kapat[kno].cuchal : 0) +
                                                    parseFloat(kapat[kno] && !isNaN(kapat[kno].ckhadya) ? kapat[kno].ckhadya : 0) +
                                                    parseFloat(
                                                        knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter)
                                                            ? parseFloat(parseFloat(knoData[0].ikapatliter) * parseFloat(totalOfTotalLiter)).toFixed(2)
                                                            : 0
                                                    ) +
                                                    parseFloat(
                                                        knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill)
                                                            ? parseFloat(knoData[0].ikapatbill).toFixed(2)
                                                            : 0
                                                    ) +
                                                    parseFloat(
                                                        knoData[0].mhvah !== null && !isNaN(knoData[0].mhvah)
                                                            ? parseFloat(parseFloat(knoData[0].mhvah) * parseFloat(totalOfTotalLiter)).toFixed(2)
                                                            : 0
                                                    ) +
                                                    parseFloat(knoData[0].ratibkapat)
                                                ).toFixed(2)}
                                            </Text>
                                        </View>
                                    )}
                                </View>

                                {localStorage.getItem("billtype") === "oldbill" ? (
                                    <View style={styles.grayhead}>
                                        <Text style={styles.column1Labelgreen}>{t("billprint3.billBox.netPayableOld")}</Text>
                                        <Text style={styles.column1Labelgreen}>
                                            {parseFloat(ada).toFixed(localStorage.getItem("round") === "on" ? 0 : 2)}
                                        </Text>
                                    </View>
                                ) : (
                                    <View style={styles.grayhead}>
                                        <Text style={styles.column1Labelgray}>{t("billprint3.billBox.netPayableOld")}</Text>
                                        <Text style={styles.column1Labelgray}>
                                            {parseFloat(
                                                parseFloat(sumOfFifthTable) -
                                                parseFloat(
                                                    parseFloat(knoData[0].mhliter * knoData[0].mhthev) +
                                                    parseFloat(knoData[0].gayliter * knoData[0].gaythev) +
                                                    parseFloat(kapat[kno] && !isNaN(kapat[kno].cuchal) ? kapat[kno].cuchal : 0) +
                                                    parseFloat(kapat[kno] && !isNaN(kapat[kno].ckhadya) ? kapat[kno].ckhadya : 0) +
                                                    parseFloat(
                                                        knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter)
                                                            ? parseFloat(parseFloat(knoData[0].ikapatliter) * parseFloat(totalOfTotalLiter)).toFixed(2)
                                                            : 0
                                                    ) +
                                                    parseFloat(
                                                        knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill)
                                                            ? parseFloat(knoData[0].ikapatbill).toFixed(2)
                                                            : 0
                                                    ) +
                                                    parseFloat(
                                                        knoData[0].mhvah !== null && !isNaN(knoData[0].mhvah)
                                                            ? parseFloat(parseFloat(knoData[0].mhvah) * parseFloat(totalOfTotalLiter)).toFixed(2)
                                                            : 0
                                                    )
                                                ).toFixed(2)
                                            ).toFixed(2)}
                                        </Text>
                                    </View>
                                )}
                            </View>

                        </View>
                        <View style={styles.line} />
                        {/* <Image style={styles.image} src={Logo} /> */}
                        {/* <View style={styles.imagerow}>
                            <View style={styles.simplerow}>


                            </View>
                            <Text style={styles.imgtext}>{"सॉफ्टवेअर खरेदीसाठी संपर्क : 800-788-9200"}</Text>
                        </View> */}

                        {index < Object.keys(data).length - 1 && <Text style={styles.pageBreak} />}

                    </View>)}
            </Page>

        </>
    );

}

export default Billprint;
